import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../Store/StoreInit';
import {
  Button,
  FormLabel,
  HStack,
  Progress,
  Select,
  Stack,
} from '@chakra-ui/react';
import React from 'react';
import UnmappedHealthPlanPg from './UnmappedHealthPlanPg';
import { IUnmappedHealthPlanNameItem } from '../Infrastructure/Interfaces';
import { fetchUnmappedHealthPlansList } from '../Store/GetDropDownsValuesReducer';
import { IoIosSearch } from 'react-icons/io';

interface RootState {  
  unmappedHealthPlanList: {  
    unmappedHealthPlanList: IUnmappedHealthPlanNameItem[];  
    loading: boolean;  
  };  
}  

const UnmappedHealthPlan: React.FC = () => {  
  const dispatch = useDispatch<AppDispatch>();
  const { unmappedHealthPlanList, loading } = useSelector((state: RootState) => state.unmappedHealthPlanList);  

  const [dataLoading, setDataLoading] = useState(false);
  const arrregionlist: string[] = (process.env.REACT_APP_REGION_LIST as string).split(',');

  const [data, setdata] = useState({
    region: '',
    planType: '',
  });

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata({ ...data, [id]: value });
  };

  useEffect(() => {
    setDataLoading(false);
  }, [unmappedHealthPlanList]);

  const getFilterData = (e: any) => {
    if (data.region.trim() != '') {
      setDataLoading(true);
      dispatch(fetchUnmappedHealthPlansList(data.region));
    }
  };

  return (
    <>
      <HStack>
        <FormLabel>Region</FormLabel>
        <Select
          width={60}
          placeholder="--select Region--"
          name="region"
          id="region"
          onChange={e => handleChange(e)}
        >
          {arrregionlist?.map(region => (
              <option key={region} value={region}>
                {region}
              </option>
            ))}
        </Select>
        <Button
          ml="1rem"
          variant="outline"
          size="md"
          leftIcon={<IoIosSearch />}
          onClick={e => getFilterData(e)}
        >
          Search
        </Button>
      </HStack>
      {loading ? (
        <>
          {dataLoading && (
            <Stack padding={5} mt={20}>
              <Progress hasStripe value={64} isIndeterminate />
            </Stack>
          )}
        </>
      ) : !unmappedHealthPlanList ? (
        ''
      ) : (
          <UnmappedHealthPlanPg
            unmappedHealthPlanList={unmappedHealthPlanList}
          />
      )}
    </>
  );
}

export default UnmappedHealthPlan;
